import React, { useEffect, useRef, useState } from "react";
import "./style.scss";

import bag_decor_img from "assets/imgs/CTKMDEALHOT15/right_decor.svg";
import vnpt_logo from "assets/imgs/CTKMCashback50/vnpt-logo-mobile.png";
import vnpt_logo_desktop from "assets/imgs/CTKMT7/Logo_VNPT.png";
import stepGetVoucher1 from "assets/imgs/CTKMCashback50/iPhone14-1.png";
import stepGetVoucher2 from "assets/imgs/CTKMCashback50/iPhone14-2.png";
import stepGetVoucher3 from "assets/imgs/CTKMCashback50/iPhone14-3.png";
import stepGetVoucher4 from "assets/imgs/CTKMCashback50/iPhone14-4.png";
import stepGetVoucher5 from "assets/imgs/CTKMCashback50/iPhone14-5.png";
import myvnpt_logo from "assets/imgs/CTKMT7/Logo_MyVNPT_Footer.png";
import qrcode from "assets/icons/QRStore.svg";
import iosStore from "assets/imgs/appstore.png";
import androiStore from "assets/imgs/ggplay.png";
import fire_icon from "assets/imgs/CTKMCashback50/fire-icon.png";
import banner from "assets/imgs/CTKMCashback50/banner.jpg";

import { CTKM_CASHBACK_50_CAT_ID, CTKM_CASHBACK_50_NEWS_ID, env_set } from "global/environment";
import Swiper from 'react-id-swiper';

const CTKMCashback50 = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth > 991 ? false : true);
  const swiperRef = useRef(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const STORE_IOS = "https://apps.apple.com/vn/app/my-vnpt/id1017188399?l=vi";
  const STORE_ANDROID =
    "https://play.google.com/store/apps/details?id=com.vnp.myvinaphone&hl=vi";

  useEffect(() => {
    const handleLoad = () => {
      if (window.innerWidth > 991) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    };
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    };
    window.addEventListener("resize", handleResize);
    window.addEventListener("load", handleLoad);

    return () => {
      window.removeEventListener("load", handleLoad);
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const defaftParamsVoucher = {
    slidesPerView: 4,
    spaceBetween: 32,
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
    },
    on: {
      slideChange: () => {
        if (swiperRef.current && swiperRef.current.swiper) {
          setIsBeginning(swiperRef.current.swiper.isBeginning);
          setIsEnd(swiperRef.current.swiper.isEnd);
        }
      },
    },
    breakpoints:{
      290: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      370: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      1024: {
        slidesPerView: 4,
      },
    }
  };

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.swiper) {
      setIsBeginning(swiperRef.current.swiper.isBeginning);
      setIsEnd(swiperRef.current.swiper.isEnd);
    }
  }, []);

  const handleNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      if (swiperRef.current.swiper?.isEnd) {
        // swiperRef.current.swiper.slideTo(0);
      } else {
        swiperRef.current.swiper.slideNext();
      }
    }
  };

  const handlePrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      if (swiperRef.current.swiper.isBeginning) {
        // swiperRef.current.swiper.slideTo(swiperRef.current.swiper.slides.length - 1);
      } else {
        swiperRef.current.swiper.slidePrev();
      }
    }
  };

  const listStepGetVoucher = [
    {
      image: stepGetVoucher1,
      desc: `<b>Bước 1:</b> Đăng nhập ứng dụng My VNPT, chọn <span class="semi-bold">“Gói cước”</span>`,
    },
    {
      image: stepGetVoucher2,
      desc: `<b>Bước 2:</b> Chọn <span class="semi-bold">"Gói cước di động"</span>`,
    },
    {
      image: stepGetVoucher3,
      desc: `<b>Bước 3:</b> Lựa chọn gói cước khuyến mại (*) phù hợp <br /> (*) Gói cước khuyến mại là gói cước có hiển thị thông tin khuyến mại tại màn Thanh toán`,
    },
    {
      image: stepGetVoucher4,
      desc: `<b>Bước 4:</b> Chọn Phương thức thanh toán được hưởng khuyến mại (*) <br /> (*) Các phương thức thanh toán được hưởng khuyến mại: Ví VNPT Pay, Mobile Money, Tài khoản liên kết ngân hàng, QRcode có tag "Hoàn 50%" (trừ nguồn tiền Tài khoản chính).`,
    },
    {
      image: stepGetVoucher5,
      desc: `<b>Bước 5:</b> Thực hiện thanh toán bằng Phương thức đã chọn đến khi hiển thị màn hình xác nhận <span class="semi-bold">Giao dịch thành công.</span> Sau đó nhận ưu đãi hoàn tiền (trong vòng tối đa 72 giờ).`,
    },
  ];


  return (
    <div id="ctkm-cashback-50">
      <div className="wrapper">
        <div className="background">
          <div className="bg_decor">
          </div>
          <div className="right_decor">
            <img src={bag_decor_img} />
          </div>
        </div>
        <div className="contentwrapper">
          {isMobile === true && (
            <div className="logo">
              <img src={vnpt_logo} />
            </div>
          )}
          {isMobile === false && (
            <div className="logo_desktop">
              <img src={vnpt_logo_desktop} />
            </div>
          )}
          <div className="content">
            <div className="title" style={{ marginTop: "32px" }}>
              Hoàn 50% khi mua gói cước di động
            </div>
            <div className="contentCTKM" style={{ marginTop: "32px" }}>
              <div className="contentCTKM_img">
                <img src={fire_icon} alt="" srcset="" />
              </div>
              <div className="contentCTKM_content">
                <span>
                  Ưu đãi cực hot dành riêng cho thuê bao trả trước VinaPhone
                </span>
              </div>
            </div>

            {isMobile === false && (
              <div className="button_desktop" style={{ marginTop: "32px" }}>
                {env_set === 3 && (
                  <>
                    {/* staging */}
                    <a
                      className="secondary_button"
                      href={"https://my.vnpt.com.vn/app?screenCode=NEWS_DETAIL&news_id=" + CTKM_CASHBACK_50_NEWS_ID}//staging 5163
                    >
                      Xem thể lệ
                    </a>
                    <a
                      className="primary_button"
                      href={"https://my.vnpt.com.vn/app?screenCode=PACKAGE_LIST&type=1&cat=" + CTKM_CASHBACK_50_CAT_ID}
                    >
                      Đăng ký gói cước
                    </a>
                  </>
                )}
                {env_set === 2 && (
                  <>
                    {/* beta*/}
                    <a
                      className="secondary_button"
                      href={"https://my.vnpt.com.vn/app?screenCode=NEWS_DETAIL&news_id=" + CTKM_CASHBACK_50_NEWS_ID}//prod 6023
                    >
                      Xem thể lệ
                    </a>
                    <a
                      className="primary_button"
                      href={"https://my.vnpt.com.vn/app?screenCode=PACKAGE_LIST&type=1&cat=" + CTKM_CASHBACK_50_CAT_ID}
                    >
                      Đăng ký gói cước
                    </a>
                  </>
                )}
                {env_set === 1 && (
                  <>
                    {/* prod*/}
                    <a
                      className="secondary_button"
                      href={"https://stagingv2.myvnpt.com.vn/app?screenCode=NEWS_DETAIL&news_id=" + CTKM_CASHBACK_50_NEWS_ID}//prod 6023
                    >
                      Xem thể lệ
                    </a>
                    <a
                      className="primary_button"
                      href={"https://stagingv2.myvnpt.com.vn/app?screenCode=PACKAGE_LIST&type=1&cat=" + CTKM_CASHBACK_50_CAT_ID}
                    >
                      Đăng ký gói cước
                    </a>
                  </>
                )}
              </div>
            )}
            
            <div className="banner" style={{ marginTop: "32px" }}>
              <img src={banner} />
            </div>
            <div className="contentCTKM_afterBanner">
              <div className="subtitle2">
                Đừng bỏ lỡ: My VNPT chiêu đãi bạn deal hot 50%! 
              </div>
              <div className="contentCTKM_afterBanner_title">
                <div>
                  Hoàn tiền cực mê! Đăng ký gói cước DI ĐỘNG cho chính mình trên ứng dụng My VNPT
                </div>
                <div className="contentCTKM_afterBanner_des">
                  <div>🔹 Hoàn tiền 50% tối đa 50.000đ khi đăng ký gói cước Data/Combo cho chính mình</div>
                  <div>🔹 Thời gian diễn ra chương trình: từ ngày 01/06/2025 đến ngày 30/06/2025</div>
                  <div>🔹 Áp dụng cho thuê bao di động VinaPhone trả trước. Mỗi khách hàng nhận được tối đa 03 lần ưu đãi/01 tháng (tính theo 03 giao dịch thành công sớm nhất)</div>
                  <div>🔹 Không áp dụng với phương thức thanh toán Tài khoản chính di động</div>
                </div>
              </div>
            </div>
          </div>

          {isMobile === true && (
            <>
              <div className="separate_graybar"></div>
            </>
          )}

          <div className="subtitle2" style={{ paddingTop: "40px", margin: "0 16px" }}>
            Hướng dẫn Đăng kí gói cước di động 
          </div>
          <div className="ladding-pages-carousel">
            <div className="swiper-ladding-pages">
              <Swiper
                ref={swiperRef}
                {...defaftParamsVoucher}
              >
                {listStepGetVoucher.map((item, index) => (
                  <div style={{boxSizing: "border-box"}}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "32px" }}>
                      <div className="image">
                        <img src={item.image} alt="" />
                      </div>
                      <div
                        className="content-carousel"
                        dangerouslySetInnerHTML={{
                          __html: item.desc,
                        }}
                      />
                    </div>
                  </div>
                ))}
              </Swiper>
              {!isMobile
                && (
                <>
                  <div
                    className={`swiper-button-prev ${!isBeginning ? 'active' : ''}`}
                    onClick={handlePrev}
                  />
                  <div
                    className={`swiper-button-next ${!isEnd ? 'active' : ''}`}
                    onClick={handleNext}
                  />
                </>
              )}
            </div>
          </div>
          {isMobile === true && (
            <div className="buttons" style={{ marginTop: "86px" }}>
              {env_set === 3 && (
                <>
                  {/* staging */}
                  <a
                    className="secondary_button"
                    href={"https://my.vnpt.com.vn/app?screenCode=NEWS_DETAIL&news_id=" + CTKM_CASHBACK_50_NEWS_ID}//staging 5163
                  >
                    Xem thể lệ
                  </a>
                  <a
                    className="primary_button"
                    href={"https://my.vnpt.com.vn/app?screenCode=PACKAGE_LIST&type=1&cat=" + CTKM_CASHBACK_50_CAT_ID}
                  >
                    Đăng ký gói cước
                  </a>
                </>
              )}
              {env_set === 2 && (
                <>
                  {/* beta*/}
                  <a
                    className="secondary_button"
                    href={"https://my.vnpt.com.vn/app?screenCode=NEWS_DETAIL&news_id=" + CTKM_CASHBACK_50_NEWS_ID}//prod 5764
                  >
                    Xem thể lệ
                  </a>
                  <a
                    className="primary_button"
                    href={"https://my.vnpt.com.vn/app?screenCode=PACKAGE_LIST&type=1&cat=" + CTKM_CASHBACK_50_CAT_ID}
                  >
                    Đăng ký gói cước
                  </a>
                </>
              )}
              {env_set === 1 && (
                <>
                  {/* prod*/}
                  <a
                    className="secondary_button"
                    href={"https://stagingv2.myvnpt.com.vn/app?screenCode=NEWS_DETAIL&news_id=" + CTKM_CASHBACK_50_NEWS_ID}//prod 5764
                  >
                    Xem thể lệ
                  </a>
                  <a
                    className="primary_button"
                    href={"https://stagingv2.myvnpt.com.vn/app?screenCode=PACKAGE_LIST&type=1&cat=" + CTKM_CASHBACK_50_CAT_ID}
                  >
                    Đăng ký gói cước
                  </a>
                </>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="footer_ctkm15">
        <div className="content_wrapper">
          <div className="icon_wrapper">
            <div className="logo">
              <img src={myvnpt_logo} alt="" srcset="" />
            </div>
            <div className="download">
              <div className="store_wrapper">
                <div className="icons">
                  <a href={STORE_IOS}><img src={iosStore} alt="" srcset="" /></a>
                  <a href={STORE_ANDROID}><img src={androiStore} alt="" srcset="" /></a>
                </div>
                <div className="text">Truy cập App Store/ Google Play hoặc Quét mã để tải ngay ứng dụng My VNPT</div>
              </div>
              <div className="QRCODE">
                <img src={qrcode} alt="" srcset="" />
              </div>
            </div>
          </div>
          <div className="copyright">© 2018 Bản quyền của Tổng Công ty Truyền thông VNPT-Media</div>
        </div>
      </div>
    </div>
  );
};

export default CTKMCashback50;
